import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { AUTH_VERSION } from "./localStoarege";

const LOGIN_PATHS = ["/", "/clinic", "/hud", "/account", "/doctor", "/medical"];

const AuthVersionGuard = () => {
    const location = useLocation();

    useEffect(() => {
        const isLoginPage = LOGIN_PATHS.some(
            (p) => location.pathname === p || location.pathname === p + "/"
        );
        if (isLoginPage) return;

        const storedVersion = localStorage.getItem("auth_version");
        if (storedVersion !== AUTH_VERSION) {
            localStorage.clear();
            window.location.replace("/");
        }
    }, [location.pathname]);

    return null;
};

export default AuthVersionGuard;
